import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { editAddressClick, editPassportAddressClick } from './actions';
import { connect } from 'react-redux';
import {translate} from "react-i18next";

@translate(['modal'], {wait:true})
class AddressTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      address: {
        subject: this.props.address.subject || '',
        region: this.props.address.region || '',
        cityType: this.props.address.cityType || '',
        cityName: this.props.address.cityName || '',
        streetName: this.props.address.streetName || '',
        village: this.props.address.village || '',
        building: this.props.address.building || '',
        corpus: this.props.address.corpus || '',
        vladenie: this.props.address.vladenie || '',
        stroenie: this.props.address.stroenie || '',
        flat: this.props.address.flat || '',
        postCode: this.props.address.postCode || '',
      },
      passportAddress: {
        subject: this.props.passportAddress.subject || '',
        region: this.props.passportAddress.region || '',
        cityType: this.props.passportAddress.cityType || '',
        cityName: this.props.passportAddress.cityName || '',
        streetName: this.props.passportAddress.streetName || '',
        village: this.props.passportAddress.village || '',
        building: this.props.passportAddress.building || '',
        corpus: this.props.passportAddress.corpus || '',
        vladenie: this.props.passportAddress.vladenie || '',
        stroenie: this.props.passportAddress.stroenie || '',
        flat: this.props.passportAddress.flat || '',
        postCode: this.props.passportAddress.postCode || '',
      },
    };
    this.handleSaveClick = this.handleSaveClick.bind(this);
  }

  handleSaveClick(e) {
    e.preventDefault();

    this.props.addressClick(this.state.address);
    this.props.passportAddressClick(this.state.passportAddress);
  }

  render() {
    const {t} = this.props;
    return (
      <div id="account__tab-address" className="popup__tab active">
        <form className="popupForm grayPopupForm popupForm-short" action="#">
          <div className="popup__settings-row">
            <div className="popup__settings__title popup__settings__title-long">{t('modal:address__header')}</div>
            <div className="popup__settings__holder">
              <div className="row">
                <label className="popupForm__label">{t('modal:address__subject')}</label>
                <div className="wrap">
                  <input
                    className="inputText size14"
                    type="text"
                    defaultValue={this.state.address.subject}
                    onChange={(e) => {
                      const address = Object.assign({}, this.state.address);
                      address.subject = e.target.value;
                      this.setState({
                        address,
                      });
                    }}
                    />
                </div>
              </div>
              <div className="row">
                <label className="popupForm__label">{t('modal:address__region')}</label>
                <div className="wrap">
                  <input
                    className="inputText size14"
                    type="text"
                    defaultValue={this.state.address.region}
                    onChange={(e) => {
                      const address = Object.assign({}, this.state.address);
                      address.region = e.target.value;
                      this.setState({
                        address,
                      });
                    }}
                    />
                </div>
              </div>
              <div className="row">
                <label className="popupForm__label">{t('modal:address__city-type')}</label>
                <div className="wrap">
                  <input
                    className="inputText size14"
                    type="text"
                    defaultValue={this.state.address.cityType}
                    onChange={(e) => {
                      const address = Object.assign({}, this.state.address);
                      address.cityType = e.target.value;
                      this.setState({
                        address,
                      });
                    }}
                    />
                </div>
              </div>
              <div className="row colRow">
                <div className="col col-9">
                  <label className="popupForm__label">{t('modal:address__city-name')}</label>
                  <div className="wrap">
                    <input
                      className="inputText size14"
                      type="text"
                      defaultValue={this.state.address.cityName}
                      onChange={(e) => {
                        const address = Object.assign({}, this.state.address);
                        address.cityName = e.target.value;
                        this.setState({
                          address,
                        });
                      }}
                      />
                  </div>
                </div>
                <div className="col col-3">
                  <label className="popupForm__label">{t('modal:address__index')}</label>
                  <div className="wrap">
                    <input
                      className="inputText size14"
                      type="text"
                      defaultValue={this.state.address.postCode}
                      onChange={(e) => {
                        const address = Object.assign({}, this.state.address);
                        address.postCode = e.target.value;
                        this.setState({
                          address,
                        });
                      }}
                      />
                  </div>
                </div>
              </div>
              <div className="row colRow">
                <div className="col col-9">
                  <label className="popupForm__label">{t('modal:address__street-name')}</label>
                  <div className="wrap">
                    <input
                      className="inputText size14"
                      type="text"
                      defaultValue={this.state.address.streetName}
                      onChange={(e) => {
                        const address = Object.assign({}, this.state.address);
                        address.streetName = e.target.value;
                        this.setState({
                          address,
                        });
                      }}
                      />
                  </div>
                </div>
                <div className="col col-3">
                  <label className="popupForm__label">{t('modal:address__building')}</label>
                  <div className="wrap">
                    <input
                      className="inputText size14"
                      type="text"
                      defaultValue={this.state.address.building}
                      onChange={(e) => {
                        const address = Object.assign({}, this.state.address);
                        address.building = e.target.value;
                        this.setState({
                          address,
                        });
                      }}
                      />
                  </div>
                </div>
              </div>
              <div className="row colRow">
                <div className="col col-3">
                  <label className="popupForm__label">{t('modal:address__corpus')}</label>
                  <div className="wrap">
                    <input
                      className="inputText size14"
                      type="text"
                      defaultValue={this.state.address.corpus}
                      onChange={(e) => {
                        const address = Object.assign({}, this.state.address);
                        address.corpus = e.target.value;
                        this.setState({
                          address,
                        });
                      }}
                      />
                  </div>
                </div>
                <div className="col col-3">
                  <label className="popupForm__label">{t('modal:address__stroenie')}</label>
                  <div className="wrap">
                    <input
                      className="inputText size14"
                      type="text"
                      defaultValue={this.state.address.stroenie}
                      onChange={(e) => {
                        const address = Object.assign({}, this.state.address);
                        address.stroenie = e.target.value;
                        this.setState({
                          address,
                        });
                      }}
                      />
                  </div>
                </div>
                <div className="col col-3">
                  <label className="popupForm__label">{t('modal:address__vladenie')}</label>
                  <div className="wrap">
                    <input
                      className="inputText size14"
                      type="text"
                      defaultValue={this.state.address.vladenie}
                      onChange={(e) => {
                        const address = Object.assign({}, this.state.address);
                        address.vladenie = e.target.value;
                        this.setState({
                          address,
                        });
                      }}
                      />
                  </div>
                </div>
                <div className="col col-3">
                  <label className="popupForm__label">{t('modal:address__flat')}</label>
                  <div className="wrap">
                    <input
                      className="inputText size14"
                      type="text"
                      defaultValue={this.state.address.flat}
                      onChange={(e) => {
                        const address = Object.assign({}, this.state.address);
                        address.flat = e.target.value;
                        this.setState({
                          address,
                        });
                      }}
                      />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="popup__settings-row">
            <div className="popup__settings__title popup__settings__title-long">{t('modal:address__header-living')}</div>
            <div className="popup__settings__holder">
              <div className="row">
                <label className="popupForm__label">{t('modal:address__subject')}</label>
                <div className="wrap">
                  <input
                    className="inputText size14"
                    type="text"
                    defaultValue={this.state.passportAddress.subject}
                    onChange={(e) => {
                      const passportAddress = Object.assign({}, this.state.passportAddress);
                      passportAddress.subject = e.target.value;
                      this.setState({
                        passportAddress,
                      });
                    }}
                    />
                </div>
              </div>
              <div className="row">
                <label className="popupForm__label">{t('modal:address__region')}</label>
                <div className="wrap">
                  <input
                    className="inputText size14"
                    type="text"
                    defaultValue={this.state.passportAddress.region}
                    onChange={(e) => {
                      const passportAddress = Object.assign({}, this.state.passportAddress);
                      passportAddress.region = e.target.value;
                      this.setState({
                        passportAddress,
                      });
                    }}
                    />
                </div>
              </div>
              <div className="row">
                <label className="popupForm__label">{t('modal:address__city-type')}</label>
                <div className="wrap">
                  <input
                    className="inputText size14"
                    type="text"
                    defaultValue={this.state.passportAddress.cityType}
                    onChange={(e) => {
                      const passportAddress = Object.assign({}, this.state.passportAddress);
                      passportAddress.cityType = e.target.value;
                      this.setState({
                        passportAddress,
                      });
                    }}
                    />
                </div>
              </div>
              <div className="row colRow">
                <div className="col col-9">
                  <label className="popupForm__label">{t('modal:address__city-name')}</label>
                  <div className="wrap">
                    <input
                      className="inputText size14"
                      type="text"
                      defaultValue={this.state.passportAddress.cityName}
                      onChange={(e) => {
                        const passportAddress = Object.assign({}, this.state.passportAddress);
                        passportAddress.cityName = e.target.value;
                        this.setState({
                          passportAddress,
                        });
                      }}
                      />
                  </div>
                </div>
                <div className="col col-3">
                  <label className="popupForm__label">{t('modal:address__index')}</label>
                  <div className="wrap">
                    <input
                      className="inputText size14"
                      type="text"
                      defaultValue={this.state.passportAddress.postCode}
                      onChange={(e) => {
                        const passportAddress = Object.assign({}, this.state.passportAddress);
                        passportAddress.postCode = e.target.value;
                        this.setState({
                          passportAddress,
                        });
                      }}
                      />
                  </div>
                </div>
              </div>
              <div className="row colRow">
                <div className="col col-9">
                  <label className="popupForm__label">{t('modal:address__street-name')}</label>
                  <div className="wrap">
                    <input
                      className="inputText size14"
                      type="text"
                      defaultValue={this.state.passportAddress.streetName}
                      onChange={(e) => {
                        const passportAddress = Object.assign({}, this.state.passportAddress);
                        passportAddress.streetName = e.target.value;
                        this.setState({
                          passportAddress,
                        });
                      }}
                      />
                  </div>
                </div>
                <div className="col col-3">
                  <label className="popupForm__label">{t('modal:address__building')}</label>
                  <div className="wrap">
                    <input
                      className="inputText size14"
                      type="text"
                      defaultValue={this.state.passportAddress.building}
                      onChange={(e) => {
                        const passportAddress = Object.assign({}, this.state.passportAddress);
                        passportAddress.building = e.target.value;
                        this.setState({
                          passportAddress,
                        });
                      }}
                      />
                  </div>
                </div>
              </div>
              <div className="row colRow">
                <div className="col col-3">
                  <label className="popupForm__label">{t('modal:address__corpus')}</label>
                  <div className="wrap">
                    <input
                      className="inputText size14"
                      type="text"
                      defaultValue={this.state.passportAddress.corpus}
                      onChange={(e) => {
                        const passportAddress = Object.assign({}, this.state.passportAddress);
                        passportAddress.corpus = e.target.value;
                        this.setState({
                          passportAddress,
                        });
                      }}
                      />
                  </div>
                </div>
                <div className="col col-3">
                  <label className="popupForm__label">{t('modal:address__stroenie')}</label>
                  <div className="wrap">
                    <input
                      className="inputText size14"
                      type="text"
                      defaultValue={this.state.passportAddress.stroenie}
                      onChange={(e) => {
                        const passportAddress = Object.assign({}, this.state.passportAddress);
                        passportAddress.stroenie = e.target.value;
                        this.setState({
                          passportAddress,
                        });
                      }}
                      />
                  </div>
                </div>
                <div className="col col-3">
                  <label className="popupForm__label">{t('modal:address__vladenie')}</label>
                  <div className="wrap">
                    <input
                      className="inputText size14"
                      type="text"
                      defaultValue={this.state.passportAddress.vladenie}
                      onChange={(e) => {
                        const passportAddress = Object.assign({}, this.state.passportAddress);
                        passportAddress.vladenie = e.target.value;
                        this.setState({
                          passportAddress,
                        });
                      }}
                      />
                  </div>
                </div>
                <div className="col col-3">
                  <label className="popupForm__label">{t('modal:address__flat')}</label>
                  <div className="wrap">
                    <input
                      className="inputText size14"
                      type="text"
                      defaultValue={this.state.passportAddress.flat}
                      onChange={(e) => {
                        const passportAddress = Object.assign({}, this.state.passportAddress);
                        passportAddress.flat = e.target.value;
                        this.setState({
                          passportAddress,
                        });
                      }}
                      />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row"><button onClick={this.handleSaveClick} type="button" className="btn">{t('modal:address__save')}</button></div>
        </form>
      </div>
    );
  }
}

AddressTab.propTypes = {
  address: PropTypes.object,
  passportAddress: PropTypes.object,
  addressClick: PropTypes.func,
  passportAddressClick: PropTypes.func,
};

export default connect(
  (state) => {
    return {
      address: state.settings.address,
      passportAddress: state.settings.passportAddress,
    };
  },
  (dispatch) => {
    return {
      addressClick(address) {
        return dispatch(editAddressClick({address}));
      },
      passportAddressClick(address) {
        return dispatch(editPassportAddressClick({address}));
      },
    };
  }
)(AddressTab);



// WEBPACK FOOTER //
// ./src/components/Modal/SettingsModal/ProfileSettings/AddressTab.js